import type { TiltScoutSnapshot } from "./tilt-scout-types";
import { FintheonNumericText } from "../numbers/FintheonNumericText";

export function TiltScoutInvalidationDrivers({
  snapshot,
  className = "",
}: {
  snapshot: TiltScoutSnapshot;
  className?: string;
}) {
  const primary = primaryDriver(snapshot);
  const secondary = secondaryDriver(snapshot);

  return (
    <div className={`min-w-0 ${className}`}>
      <p className="text-[9px] uppercase tracking-[0.13em] text-[var(--fintheon-muted)]">
        Invalidation
      </p>
      <div className="mt-1 grid grid-cols-[minmax(0,1fr)_1px_minmax(0,1fr)] gap-2">
        <Driver label="Primary Driver" value={primary} />
        <span className="h-full min-h-10 bg-gradient-to-b from-transparent via-[var(--fintheon-accent)]/24 to-transparent" />
        <Driver label="Secondary Driver" value={secondary} />
      </div>
    </div>
  );
}

function Driver({ label, value }: { label: string; value: string }) {
  return (
    <div className="min-w-0">
      <span className="text-[9px] text-[var(--fintheon-text)]/38">{label}</span>
      <p className="mt-0.5 text-[10px] leading-snug text-[var(--fintheon-text)]/76">
        <FintheonNumericText text={value} />
      </p>
    </div>
  );
}

function primaryDriver(snapshot: TiltScoutSnapshot) {
  const event = snapshot.deskPlanPreview?.eventText ?? snapshot.eventText;
  const forecast = snapshot.deskPlanPreview?.forecastText;
  if (forecast && !/pending|unavailable/i.test(forecast)) {
    return `${event}: outcome contradicts ${forecast}.`;
  }
  return snapshot.deskPlanPreview?.changeText ?? snapshot.invalidationText;
}

function secondaryDriver(snapshot: TiltScoutSnapshot) {
  const inverse =
    snapshot.whatWouldChange?.find((item) =>
      /vix|oil|energy|rates|bonds|dxy|dollar|reject|contradiction|arbitrum/i.test(
        item,
      ),
    ) ?? snapshot.invalidationText;
  return inverse || "VIX/oil/rates fail; risk channel stops confirming.";
}
